import { Trophy, ShieldCheck, Zap, FileCheck, BadgeCheck, PhoneCall } from 'lucide-react';
import { WHY_US } from '../mock/data';

const ICONS = { Trophy, ShieldCheck, Zap, FileCheck, BadgeCheck, PhoneCall };

export default function WhyChoose() {
  return (
    <section id="why" className="py-24 lg:py-32 bg-ink-soft border-y border-white/5">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="max-w-2xl">
          <div className="eyebrow">Why Choose Us</div>
          <h2 className="section-title">The Better Difference.</h2>
          <p className="section-lede">
            Every fence company promises quality. We measure ours by the neighbors who point at their fence and smile.
          </p>
        </div>

        <div className="mt-14 grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {WHY_US.map((w) => {
            const Icon = ICONS[w.icon];
            return (
              <div
                key={w.title}
                className="group p-7 rounded-md border border-white/10 bg-ink-panel hover:border-gold/60 transition-[border-color,transform] duration-500 hover:-translate-y-1"
              >
                <div className="w-12 h-12 rounded-md bg-gold/15 text-gold flex items-center justify-center group-hover:bg-gold group-hover:text-ink transition-colors">
                  {Icon && <Icon className="w-6 h-6" />}
                </div>
                <h3 className="mt-5 font-display uppercase text-2xl text-cream tracking-tight">{w.title}</h3>
                <p className="mt-2 text-cream/65 leading-relaxed">{w.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
